import { ChangeDetectorRef, Input, SimpleChange, SimpleChanges, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';
import { ControlUser } from 'src/app/model/controlUser';
import { DevicePilomat } from 'src/app/model/devicePilomat';
import { DeviceState } from 'src/app/model/deviceState';
import { SerialsList } from 'src/app/model/serialsList';
import { DeviceService } from 'src/app/service/device.service';
import { Log } from 'src/app/util/log';

@Component({
  selector: 'app-owner-devices-map',
  templateUrl: './owner-devices-map.component.html',
  styleUrls: ['./owner-devices-map.component.css']
})
export class OwnerDevicesMapComponent implements OnInit {

  @Input() reload: Object;
  @Input() owner: ControlUser;
  @ViewChild('ownerdevicesmaploader', { static: true }) loader;

  deviceList: DevicePilomat[];

  map: google.maps.Map;
  latitude: number;
  longitude: number;
  mapZoom: number;

  timeInterval: Subscription;

  constructor(
    private deviceService: DeviceService,
    private cdRef: ChangeDetectorRef,
    private router: Router) {

  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {

    setTimeout(() => {
      this.loader.showLoading();
    });
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.owner) {

      const ownerChange: SimpleChange = changes.owner;

      this.getOwnerDevices(ownerChange.currentValue.uid);
    }
    else if (changes.reload) {

      Log.debug("must reload ");

      this.getOwnerDevices(this.owner.uid);
    }
  }

  getOwnerDevices(uid: string) {

    Log.debug("getOwnerDevices: " + uid);

    this.loader.showLoading();

    this.deviceService.getOwnerDevices(uid).subscribe(devices => {

      Log.debug("getOwnerDevices: " + JSON.stringify(devices));

      this.deviceList = devices;

      setTimeout(() => {
        this.manageMapBounds();
      }, 1000);

      this.startUpdatingDevicesStates();
      this.loader.hideLoading();

      this.cdRef.detectChanges();

    }, error => {

      this.loader.hideLoading();
      this.loader.showError();

      this.cdRef.detectChanges();
    });
  }

  startUpdatingDevicesStates() {

    Log.debug("startUpdatingDevicesStates");

    let serials: SerialsList = new SerialsList();

    for (let i = 0; i < this.deviceList.length; i++) {
      serials.devices.push(this.deviceList[i].serial.toString());
    }

    this.timeInterval = interval(15000).pipe(
      startWith(0),
      switchMap(() => this.deviceService.getDevicesState(serials))
    ).subscribe(res => this.updateDeviceIcons(res), err => Log.debug('err: ' + JSON.stringify(err)));
  }


  updateDeviceIcons(data: DeviceState[]) {

    Log.debug("updateDeviceIcons: " + JSON.stringify(data));

    for (let i = 0; i < data.length; i++) {

      for (let j = 0; j < this.deviceList.length; j++) {

        if (data[i].serial.toString() == this.deviceList[j].serial.toString()) {

          this.deviceList[j].updateState(data[i]);
        }
      }
    }
  }



  onMarkerClicked(device) {
    Log.debug("onMarkerClicked: " + JSON.stringify(device));
  }

  public mapReadyHandler(map: google.maps.Map): void {
    this.map = map;
  }

  public manageMapBounds() {
    const bounds: google.maps.LatLngBounds = new google.maps.LatLngBounds();
    for (const device of this.deviceList) {
      bounds.extend(new google.maps.LatLng(device.latitude, device.longitude));
    }
    this.map.fitBounds(bounds);


    Log.debug("\n\n\n this.zoom = " + this.map.getZoom());
    if (this.map.getZoom() > 20) {
      this.map.setZoom(20);
    } else if (this.map.getZoom() < 4) {
      this.map.setZoom(4);
    }
    Log.debug("\n\n\n this.zoom after changes = " + this.map.getZoom());
  }

  onDetailsButtonClicked(device: DevicePilomat) {
    // Log.debug(device);
    this.router.navigate(['device/' + device.serial]);
  }
}
